export default [
    {
        title: $t('integration.alarm_switch_event'),
        type: 'triggerEvent'
    }
];
